import { memo } from 'react';
import { NodeProps } from '@xyflow/react';
import { LocationMarker } from '@lp/features/RoutePlanner/components/RouteViewList/LocationMarker';
import { SegmentTypeEnum } from '@/api/apis/route';
import { HubNodeProps } from './HubNode';
import { NodeHandleConnections } from './NodeHandleConnections';

export const AltHubNode = memo(({ data }: NodeProps<HubNodeProps>) => {
  return (
    <NodeHandleConnections>
      <LocationMarker variant="filled" type="end" segmentType={SegmentTypeEnum.hub} useMonoFont>
        {data.title}
      </LocationMarker>
    </NodeHandleConnections>
  );
});
